var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11085_73258",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00976562,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11085_73258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 9.29549V1.65674H10.9708V4.43465H6.10995V9.29549H3.33203ZM33.8875 9.29549V4.43465H29.0266V1.65674H36.6654V9.29549H33.8875ZM3.33203 38.3234V30.6847H6.10995V35.5455H10.9708V38.3234H3.33203ZM29.0266 38.3234V35.5455H33.8875V30.6847H36.6654V38.3234H29.0266ZM11.1099 30.5455H28.8875V9.43465H11.1099V30.5455ZM11.1099 33.3234C10.3599 33.3234 9.70939 33.048 9.15828 32.4972C8.60745 31.946 8.33203 31.2955 8.33203 30.5455V9.43465C8.33203 8.68465 8.60745 8.0341 9.15828 7.48299C9.70939 6.93216 10.3599 6.65674 11.1099 6.65674H28.8875C29.6375 6.65674 30.288 6.93216 30.8391 7.48299C31.3899 8.0341 31.6654 8.68465 31.6654 9.43465V30.5455C31.6654 31.2955 31.3899 31.946 30.8391 32.4972C30.288 33.048 29.6375 33.3234 28.8875 33.3234H11.1099ZM15.2766 16.3788H24.7208V13.6013H15.2766V16.3788ZM15.2766 21.3788H24.7208V18.6013H15.2766V21.3788ZM15.2766 26.3788H24.7208V23.6013H15.2766V26.3788Z",
    fill: "#9602C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentScanner);
export default __webpack_public_path__ + "static/media/document_scanner.87c14f023d85bbbee94c396a259fea0f.svg";
export { ForwardRef as ReactComponent };